import Vue from 'vue';
import Textra from 'vue-textra';

Vue.use(Textra);
